import compose from '../../../../src/web/utils/react/compose';
import pure from '../../../../src/web/utils/react/pure';
import widget from '../../../../src/web/components/widgets/decorators/widget';
import HeaderText from './HeaderText';
import { NAME, ID } from './properties';

export default compose(
  pure(),
  widget(
    { name: NAME, category: 'Text', componentId: ID },
    {
      defaults: {
        rawContentState: {
          blocks: [
            {
              key: 'db2mm',
              text: 'Header Text Here',
              type: 'header-two',
              depth: 0,
              inlineStyleRanges: [],
              entityRanges: [],
            },
          ],
          entityMap: {},
        },
      },
    },
  ),
)(HeaderText);
